import { TreeNode } from 'primeng/api';
import { FilterTypes } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';

export class LegalFormCriteria extends FilterCriteria {
  public override title = 'Legal Form';
  public override type: FilterTypes = FilterTypes.LegalForm;
  legalFormSelection: TreeNode[] = null;

  public override validate(): boolean {
    return this.legalFormSelection != null && this.legalFormSelection.length > 0;
  }

  public override toString(): string {
    const s: string = this.legalFormSelection ? this.legalFormSelection.map((selection) => selection.label).join(', ') : '';
    return 'Legal Form: ' + s;
  }
}
